module.exports = __webpack_public_path__ + "img/actionlab.8fa827c6.svg";